<template>
  <CustomSelect :size="size" :options="options" :active="active" @change="onChange" />
</template>

<script>
import CustomSelect from "./CustomSelect";

export default {
  name: "SelectRedirect",
  components: {
    CustomSelect,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    active: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
      validator: value => ["default", "small"].includes(value),
    },
  },
  methods: {
    onChange(value) {
      const selected = this.options.find(opt => opt.value === value);
      window.location.assign(selected.link);
    },
  },
};
</script>
